var App = App || {};

App.Accordions = (function ($) {
    "use strict";

    function init() {
        $('.accordion .accordion-collapse').on('show.bs.collapse', function () {
            $(this).parents(".accordion-item").removeClass("hidden").addClass("showing")
        })
        $('.accordion .accordion-collapse').on('shown.bs.collapse', function () {
            $(this).parents(".accordion-item").removeClass("showing").addClass("shown")
        })
        $('.accordion .accordion-collapse').on('hide.bs.collapse', function () {
            $(this).parents(".accordion-item").removeClass("shown").addClass("hiding")
        })
        $('.accordion .accordion-collapse').on('hidden.bs.collapse', function () {
            $(this).parents(".accordion-item").removeClass("hiding").addClass("hidden")
        })
    }

    function InitCarousels(testimonialsBand) {
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.Accordions.init();
});